<span *ngIf="departmentName as depName">{{depName}}</span>
